<template>
  <div>
    <!-- RMA Service Center -->
    <div>
      <h3>RMA Service Center</h3>
      <div>
        <!-- 服務據點說明欄 -->
        <label class="form-item d-flex py-5">
          <div class="w-174px mr-6">
            <h4>服務專線說明欄</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <editor
              v-model="support.service_line_description"
              :plugins="'lists link code'"
              :toolbar="'link bold bullist numlist | code'"
              :height="200"
            ></editor>
          </div>
        </label>
        <!-- 服務據點說明欄 -->
        <label class="form-item d-flex py-5">
          <div class="w-174px mr-6">
            <h4>服務據點說明欄</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <editor
              v-model="support.service_base_description"
              :plugins="'lists link code'"
              :toolbar="'link bold bullist numlist | code'"
              :height="200"
            ></editor>
          </div>
        </label>
      </div>
    </div>

    <!-- 據點分類 -->
    <div>
      <h3 class="pt-5">據點分類</h3>
      <div class="py-5">為售後服務據點做分類</div>
      <div>
        <!-- itemList -->
        <PageCollapse v-for="(item, i) in support.rma_service_center.categories" :key="i">
          <template v-slot:head>
            <h3 class="mr-auto">據點分類 {{ i + 1 }}</h3>
          </template>
          <template v-slot:actions>
            <div class="ml-auto">
              <button class="btn square mr-10px" @click="deleteCategoryItem(item)">
                <v-icon class="ink-02-medium--text">delete</v-icon>
              </button>
              <button class="btn square mr-10px" @click="downCategoryItem(item, i)">
                <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
              </button>
              <button class="btn square" @click="upCategoryItem(item, i)">
                <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
              </button>
            </div>
          </template>
          <template v-slot:body>
            <!-- Basic section -->
            <div>
              <!-- Category -->
              <label class="form-item d-flex pt-5">
                <h4 class="w-180px mr-5">Category</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-text-field
                    v-model="item.title"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </label>
              <!-- Description -->
              <label class="form-item d-flex pt-5">
                <h4 class="w-180px mr-5">Description</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-textarea
                    v-model="item.description"
                    outlined
                    dense
                  ></v-textarea>
                </div>
              </label>
              <!-- Tags -->
              <label class="d-flex px-5 pt-5">
                <h4 class="w-180px mr-5">Tags</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-text-field
                    v-model="item.tags"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </label>
            </div>
          </template>
        </PageCollapse>
        <!-- add item -->
        <div class="mt-5">
          <button class="btn btn-outlined w-100 justify-start" @click="addCategoryItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>據點分類</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 售後服務據點 -->
    <div>
      <h3 class="pt-5">售後服務據點</h3>
      <div class="py-5">呈現於Support Page 售後服務</div>
      <div>
        <!-- itemList -->
        <PageCollapse v-for="(item, i) in support.rma_service_center.services" :key="i">
          <template v-slot:head>
            <h3 class="mr-auto">售後服務據點 {{ i + 1 }}</h3>
          </template>
          <template v-slot:actions>
            <div class="ml-auto">
              <button class="btn square mr-10px" @click="deleteItem(item)">
                <v-icon class="ink-02-medium--text">delete</v-icon>
              </button>
              <button class="btn square mr-10px" @click="downItem(item, i)">
                <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
              </button>
              <button class="btn square" @click="upItem(item, i)">
                <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
              </button>
            </div>
          </template>
          <template v-slot:body>
            <!-- Basic section -->
            <div>
              <!-- 據點名稱 -->
              <label class="form-item d-flex pt-5">
                <h4 class="w-180px mr-5">據點名稱</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-text-field
                    v-model="item.name"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </label>
              <!-- 營業時間 -->
              <label class="form-item d-flex pt-5">
                <h4 class="w-180px mr-5">據點分類</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-autocomplete
                    v-model="item.support_service_category_id"
                    :items="support.rma_service_center.categories"
                    placeholder="請選擇據點分類"
                    item-text="title"
                    item-value="id"
                    outlined
                    dense
                  >
                  </v-autocomplete>
                </div>
              </label>
              <!-- 電話 -->
              <label class="form-item d-flex pt-5">
                <h4 class="w-180px mr-5">電話</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-text-field
                    v-model="item.phone"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </label>
              <!-- 地址 -->
              <label class="form-item d-flex pt-5">
                <h4 class="w-180px mr-5">地址</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-textarea
                    v-model="item.address"
                    outlined
                    dense
                  ></v-textarea>
                </div>
              </label>
              <!-- 營業時間 -->
              <label class="form-item d-flex pt-5">
                <h4 class="w-180px mr-5">營業時間</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-textarea
                    v-model="item.business_hours"
                    outlined
                    dense
                  ></v-textarea>
                </div>
              </label>
              <!-- URL Link -->
              <label class="d-flex form-item pt-5">
                <h4 class="w-180px mr-5">URL Link</h4>
                <div class="flex-grow-1 flex-basis-0 my-n2">
                  <v-text-field
                    v-model="item.url"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </label>
              <!-- Image -->
              <div class="d-flex px-5 py-5">
                <div class="w-174px mr-6">
                  <h4>Image</h4>
                  <div class="h5 ink-02-medium--text">
                    建議尺寸：999px * 999px <br />
                    檔案大小限制：&lt; 1 MB
                  </div>
                </div>
                <div class="flex-grow-1 flex-basis-0 d-flex justify-end">
                  <ImgUploader
                    :imageUrl.sync="item.image"
                    :dir="'support'"></ImgUploader>
                </div>
              </div>
            </div>
          </template>
        </PageCollapse>
        <!-- add item -->
        <div class="mt-5">
          <button class="btn btn-outlined w-100 justify-start" @click="addItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加服務據點</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  props: {
    support: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    PageCollapse,
    ImgUploader,
    Editor,
  },
  methods: {
    addCategoryItem() {
      const template = {
        id: `N_${Date.now()}`,
        title: '',
        tags: '',
        description: '',
      };
      this.support.rma_service_center.categories.push(template);
    },
    deleteCategoryItem(item) {
      const index =
        this.support.rma_service_center.categories.map((option) => option.id).indexOf(item.id);
      this.support.rma_service_center.categories.splice(index, 1);
    },
    downCategoryItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.support.rma_service_center.categories.length - 1) {
        this.support.rma_service_center.categories.splice(i, 1);
        this.support.rma_service_center.categories.unshift(item);
        return;
      }
      // item become next index
      this.support.rma_service_center.categories.splice(i, 1);
      this.support.rma_service_center.categories.splice(i + 1, 0, item);
    },
    upCategoryItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.support.rma_service_center.categories.splice(i, 1);
        this.support.rma_service_center.categories.push(item);
        return;
      }
      // item become previous index
      this.support.rma_service_center.categories.splice(i, 1);
      this.support.rma_service_center.categories.splice(i - 1, 0, item);
    },
    addItem() {
      const template = {
        id: null,
        support_service_category_id: null,
        name: '',
        phone: '',
        address: '',
        business_hours: '',
        url: '',
        image: null,
      };
      this.support.rma_service_center.services.push(template);
    },
    deleteItem(item) {
      const index =
        this.support.rma_service_center.services.map((option) => option.id).indexOf(item.id);
      this.support.rma_service_center.services.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.support.rma_service_center.services.length - 1) {
        this.support.rma_service_center.services.splice(i, 1);
        this.support.rma_service_center.services.unshift(item);
        return;
      }
      // item become next index
      this.support.rma_service_center.services.splice(i, 1);
      this.support.rma_service_center.services.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.support.rma_service_center.services.splice(i, 1);
        this.support.rma_service_center.services.push(item);
        return;
      }
      // item become previous index
      this.support.rma_service_center.services.splice(i, 1);
      this.support.rma_service_center.services.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
